import { Breakpoint } from "@mui/material"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ breakpoints }) => ({
  rootSticky: {
    [breakpoints.up("sm" as Breakpoint)]: {
      position: "sticky",
      top: 0,
      left: 0,
      right: "auto",
      zIndex: 1000
    }
  },
  districtLoadingSkeleton: {
    display: "inline-block",
    width: "70px"
  }
}))
